"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSetConfigOptions = exports.defaultConfig = void 0;
var enums_1 = require("./enums");
var appender_console_native_1 = require("./appenders/appender.console-native");
/**
 * Default config {@link Timber} uses when initialized if no enhancements to it applied.
 */
exports.defaultConfig = {
    userId: 0,
    companyId: 0,
    /**
     * by default {@link LogLevel.Debug} is initialized.
     */
    minLogLevel: enums_1.LogLevel.Debug,
    appId: '',
    module: '',
    url: '',
    eventType: enums_1.EventType.Log,
    /**
     * by default {@link ConsoleNativeAppender} is initialized.
     */
    appenders: [new appender_console_native_1.ConsoleNativeAppender()],
    appenderTypes: [enums_1.AppenderType.ConsoleNative],
    /**
     * by default {@link ConfigMode.Release} is initialized.
     */
    mode: enums_1.ConfigMode.Release
};
/**
 * Default options for setting Timber config, such as config mode or appenders population rules.
 */
exports.defaultSetConfigOptions = {
    /**
     * by default is `false`. Please see more at {@link ISetConfigOptions} docs.
     */
    keepExplicitlySetAppenders: false,
    /**
     * by default {@link ConfigMode.Release} is initialized.
     */
    mode: enums_1.ConfigMode.Release
};
